<template>
  <span>
    <button
      class="boss-button pega-button display-inline"
      data-test="action-button"
      :disabled="isDisabled"
      @click="callMordalInner()"
    >
      <span>面接場所を追加</span>
    </button>
    <!-- ▼一括更新モーダル -->
    <entry-interview-place-modal-inner ref="mordal_inner" />
  </span>
</template>

<script>
import EntryInterviewPlaceModalInner from '@/components/atoms/EntryInterviewPlaceModalInner.vue'

export default {
  components: {
    EntryInterviewPlaceModalInner
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    callMordalInner () {
      this.$refs.mordal_inner.doAction()
    }
  }
}
</script>
